<template>
    <popup-modal ref="popup">
        <div id="modal" class="messageBox">
            <div class="modal-header modal-header-text">
                <h2 class="modal-title reset-password-title" id="myModalLabel"><span>{{ getTranslationText('147') }}</span></h2>
            </div>
            <div class="modal-body modal-body-text">
                <span class="forgot-pwd-msg-text">{{ getTranslationText('146') }}</span><br /><br />
                <div class="input-group login-input-group">
                    <span class="input-group-addon glyphicon glyphicon-envelope"></span>
                    <input class="form-control login-input"
                        required=""
                        type="email"
                        v-model="email"
                        :placeholder="getTranslationText('124')" />
                </div>
            </div>
            <p v-if="statusMessage" role="status" class="recovery-status">{{ statusMessage }}</p>
            <div class="modal-footer">
                <button class="btn btn-default btn-truckscience btn-primary" @click="ok" :disabled="sendingEmail"><span >{{ getTranslationText('457') }}</span></button>
                <button class="btn btn-default btn-truckscience" @click="close"><span >{{ getTranslationText('65') }}</span></button>
            </div>
        </div>
    </popup-modal>
</template>

<script>
import config from '@/services/config';
import globals from '@/services/globals';
import security from '@/services/security';
import CustomMessageBox from '@/services/CustomMessageBox';
import PopupModal from '@/components/modals/PopupModal.vue';
import { ref, nextTick, onBeforeUnmount } from 'vue';

export default {
    name: 'ForgotPasswordModal',
    components: { PopupModal },
    setup() {
        const popup = ref(null), email = ref(''), sendingEmail = ref(false), statusMessage = ref('');
        let resolvePromise, generation = 0, retryUntil = 0, acknowledgementPending = false;
        function show() {
            generation++;
            acknowledgementPending = false;
            sendingEmail.value = false;
            statusMessage.value = '';
            popup.value.open();
            return new Promise(resolve => { resolvePromise = resolve; });
        }
        function close() {
            generation++;
            sendingEmail.value = false;
            globals.hideSpinner();
            popup.value.close();
            resolvePromise?.();
            resolvePromise = undefined;
        }
        function ok() {
            if (sendingEmail.value) return;
            const remaining = Math.ceil((retryUntil - Date.now()) / 1000);
            if (remaining > 0) {
                statusMessage.value = config.getTranslationText('auth.recoveryWait', [remaining]);
                return;
            }
            if (!globals.isValidEmailAddress(email.value.trim())) {
                globals.showDialog(new CustomMessageBox(config.getMessageText('1553', globals.getActiveCultureCodeForTranslations()), config.applicationTitle, [config.getTranslationText('271')], config.getMessageReference('1553')));
                return;
            }
            const owner = generation;
            const sessionOwner = security.getIncarnation();
            statusMessage.value = '';
            sendingEmail.value = true;
            globals.showSpinner();
            security.forgottenPassword(email.value).then(() => {
                if (owner !== generation) return;
                email.value = '';
                close();
                const completed = generation;
                acknowledgementPending = true;
                nextTick(() => {
                    acknowledgementPending = false;
                    if (completed !== generation || !security.incarnationMatches(sessionOwner)) return;
                    globals.showDialog(new CustomMessageBox(config.getTranslationText('recovery.acknowledgement'), config.applicationTitle, [config.getTranslationText('271')]));
                });
            }, error => {
                if (owner !== generation) return;
                sendingEmail.value = false;
                globals.hideSpinner();
                if (error.cancelled) return;
                if (error.throttled) {
                    retryUntil = Date.now() + error.retryAfterSeconds * 1000;
                    statusMessage.value = config.getTranslationText('auth.recoveryWait', [error.retryAfterSeconds]);
                } else if (error.infrastructureUnavailable) {
                    statusMessage.value = 'Recovery is temporarily unavailable. Please try again.';
                } else if (error.offline) {
                    statusMessage.value = 'Unable to connect. Check your connection, then try again.';
                } else {
                    statusMessage.value = 'Unable to process this request. Check the address, then try again.';
                }
            });
        }
        onBeforeUnmount(() => {
            // Successful close unmounts the form before the queued OK is shown.
            // Its session still owns that acknowledgement; abandoned forms do not.
            if (!acknowledgementPending) generation++;
            if (sendingEmail.value) globals.hideSpinner();
        });
        return { popup, email, sendingEmail, statusMessage, show, close, ok, getTranslationText: config.getTranslationText };
    }
};
</script>
